interface IdCardIconProps {
    fill?: string
    size?: number
}

export const IdCardIcon = ({
    fill = '#C3CAD9',
    size = 30,
}: IdCardIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        >
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <path d="M16 10h2" />
            <path d="M16 14h2" />
            <path d="M6.17 15a3 3 0 0 1 5.66 0" />
            <circle cx="9" cy="11" r="2" />
        </svg>
    )
}
